// extracted by mini-css-extract-plugin
export var checkbox = "_7j-0";
export var circle = "_7j-3";
export var horizontalContainer = "_7j-7";
export var sm = "_7j-5";
export var switch0 = "_7j-2";
export var switchDisabled = "_7j-8";
export var switchEnabled = "_7j-1";
export var textSwitchContainer = "_7j-9";
export var textSwitchOption = "_7j-a";
export var textSwitchOptionSelected = "_7j-b";
export var verticalContainer = "_7j-6";
export var xs = "_7j-4";